<template>
    <div class="StoresList mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <div class="d-flex flex-column">
            <!-- 分隔線 -->
            <h3 class="text-center">特約商店</h3>
            <div class="border-top border-primary"></div>
            <p>&nbsp;</p>
        </div>
        <form class="form">
       <div class="row">
            <div class="d-flex flex-column col-md-6 col-sm-12">
                <div class="col px-5">
                    <select name="storetype" class="form-control bg-light" @change="onChange($event, 0)">
                        <option value="" class="text-center">-- 請選擇地區 --</option>
                        <optgroup v-for="(country, idx) in CountryListData" :label="country.countryName">
                        <option value="" v-if="country.area.length == 0"></option>
                        <option v-for="areas in country.area" :label="areas.areaName" :value="areas.areaId">{{ areas.areaName }}</option>
                        </optgroup>
                    </select>
                </div>
            </div>
            <p class="d-md-none">&nbsp;</p>
            <div class="d-flex flex-column col-md-6 col-sm-12">
                <div class="col px-5">
                    <select name="storetype" class="form-control bg-light" @change="onChange($event, 1)">
                        <option value="" class="text-center">-- 請選擇分類 --</option>
                        <option v-for="storetypes in storeTypeData" :label="storetypes.typeName" :value="storetypes.storeTypeId">{{ storetypes.typeName }}</option>
                    </select>
                </div>
            </div>
        </div>
        </form>
        <!-- 商店列表 -->
        <div class="row">
            <div class="rowflex col-md-6 col-sm-12 p-3" v-for="item in StoresListData">
                <div class="col p-3 border bg-info">
                    <p v-if="item.storePhotoUri != ''" class="text-center imgP"><img class="img-fluid" v-bind:src="item.storePhotoUri" /></p>
                    <p class="font-weight-bolder">{{item.name}}</p>
                    <p class="text-primary">分類:{{item.storeType}}</p>
                    <p class="text-primary" v-if="item.address != ''">地址:{{item.address}}</p>
                    <p class="text-right mx-n3">
                        <a class="btn btn-primary btn-block col-6 offset-6" style="border-radius: 2em 0 0 2em;" @click="GoDetail(item.storeId)">了解更多</a>
                    </p>
                </div>
            </div>
        </div>
        <!-- 頁碼 -->
        <ul class="pagination justify-content-center">
            <li v-for="(pages, idx) in PageListAll" class="page-item" :key="idx" :class="{'active': isActive[idx] }">
                <span class="page-link" v-if="idx === pIdx">{{ idx+1 }}</span>
                <a class="page-link" href="#" v-if="idx != pIdx" @click="GetStoresList(idx)">{{ idx+1 }}</a>
            </li>
        </ul>

    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'StoresList',
    components:{
        Nav,
    },
    data () {
        return {
            showLoading:'',
            DeweyUserId:'',
            PageListAll:[],
            StoresListData:[],
            isActive:{0 : true, 1:false},
            pIdx:0,
            CountryListData:[],
            myCountry:0,
            storeTypeData:[],
            myStoreType:0
        }
    },
    methods:{
        onChange(myVal, flag){
            let myFlag = flag || 0;
            if (myFlag < 1) {
                this.myCountry = myVal.target.value;
            } else {
                this.myStoreType = myVal.target.value
            }
            this.GetStoresList()
        },
        GoDetail(storeId){
            this.$router.push({
                name: 'StoresDetail',
                params: {
                    storeId:storeId,
                },
            });

        },
        GetStoresList(idx){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/ContractedStores/GetStoreList`;
            const inputdata = 
            {
                "deweyUserId": this.DeweyUserId,
                "countryId"  : this.myCountry || 0,
                "storeTypeId": this.myStoreType || 0
            };
            this.pIdx = idx || 0;//頁碼
            axios.post(api, inputdata)
            .then((response) => {
                this.showLoading = false;
                if(response.data.isSuccess){
                    response.data.page.forEach((element, index) => { 
                            this.isActive[index] = false;
                            if (index == this.pIdx ) { this.isActive[index] = true; }
                    });
                    this.PageListAll    = response.data.page; 
                    this.StoresListData = typeof response.data.page[this.pIdx] != "undefined" ? response.data.page[this.pIdx].store : {};
                }else{
                    this.StoresListData = {};
                    console.error("There was an error!", response.data.message);
                }
            })
            .catch(error => {
                this.showLoading = false;
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        },
        getCountryList(idx){
            const api =`${process.env.APIPATH}​/api/Information/GetCountryArea`;
            const inputdata = {};
            axios.post(api, inputdata)
            .then((response) => {
                if(response.data.isSuccess){ 
                    this.CountryListData = response.data.country;
                }
            })
            .catch(error => {
                this.showLoading = false;
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        },
        getStoresType(){
            const api =`${process.env.APIPATH}​/api/Information/GetStoreType`;
            const inputdata = {};
            axios.post(api, inputdata)
            .then((response) => {
                if(response.data.isSuccess){ 
                    console.log(response.data)
                    this.storeTypeData = response.data.storeType;
                }
            })
            .catch(error => {
                this.showLoading = false;
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        },
    },
    created(){
        this.DeweyUserId=JSON.parse(sessionStorage.getItem('UserData')).deweyUserId;
        this.GetStoresList();
        this.getCountryList();
        this.getStoresType();
    },
}
</script>






// WEBPACK FOOTER //
// src/components/line/StoresList.vue